import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Loader from '../../components/Loader'
import { getById } from '../../lib/RestApi/customApiHandler'
import AddTravelCategory from './AddTravelCategory'
export default function EditTravelCategory() {
  const params = useParams()
  const [travelCategory, setTravelCategory] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getById('/travel/category', params.travelCategoryId).then((res) => {
      setTravelCategory(res.data)
      setLoading(false)
    })
  }, [params.travelCategoryId])

  return <> {loading ? <Loader /> : <AddTravelCategory travelCategory={travelCategory} />} </>
}
